// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__Cc-fz","text":"Switch_text__SHsvF","track":"Switch_track__yos10","thumb":"Switch_thumb__e8r24","input":"Switch_input__yeFuK"};